import * as yup from 'yup';
import { LanguageKey } from './types';
export var validateForm = yup.object().shape({
    language: yup.string(),
});
export var languageOptions = [
    {
        id: 'en',
        name: LanguageKey.English,
    },
    {
        id: 'fr',
        name: LanguageKey.French,
    },
];
